<script lang="ts">
  import type {TextInput, CurrentResponses, QuestionOnChange} from '../types';
  import {getDisplayValue} from '../utils';
  export let question: TextInput;
  export let pageQuestionIdx: string;
  export let onChange: QuestionOnChange;
  export let currentResponses: CurrentResponses;

  $: label = getDisplayValue<TextInput>(currentResponses, question, 'label');
  const toVal = (e: any) => e.target.value;
</script>

{#if question.size === 'line'}
  <input
    class="border-2"
    name={label}
    id={`${pageQuestionIdx}`}
    value={currentResponses[pageQuestionIdx] || ''}
    on:change={(e) => {
      onChange({newValue: toVal(e)});
    }}
    on:keyup={(e) => {
      onChange({newValue: toVal(e), noEventLog: true});
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }}
  />
{:else}
  <textarea
    class="border-2 w-full h-32"
    name={label}
    id={`${pageQuestionIdx}`}
    value={currentResponses[pageQuestionIdx] || ''}
    on:change={(e) => {
      onChange({newValue: toVal(e)});
    }}
    on:keyup={(e) => {
      onChange({newValue: toVal(e), noEventLog: true});
      if (e.key === 'Enter') {
        e.preventDefault();
      }
    }}
  />
{/if}
